import {
  IGetBrandQuery,
  IBrand,
  IResponse,
  IGetEmailQuery,
  IPostEmailQuery,
} from 'interface/brand.interface';
import axiosClient from './axiosClient';
import { IPagingResponse } from 'interface/base.interface';

const BrandApi = {
  getBrand: async (
    params: IGetBrandQuery
  ): Promise<{ data: IBrand[]; total: number }> => {
    return await axiosClient.get('/abe/product/product-group', { params });
  },

  postBrand: async (
    params: IBrand
  ): Promise<{ data: IResponse; total: number }> => {
    const data = {
      grp_code: 'adminCreate012',
      grp_name: params.grp_name,
      active: 'active',
      grp_level: 3,
    };
    return await axiosClient.post('/abe/product/product-group', data);
  },

  putBrand: async (
    params: IGetBrandQuery
  ): Promise<{ data: IBrand[]; total: number }> => {
    return await axiosClient.put('/abe/product/product-group', { params });
  },

  deleteBrand: async (
    params: IGetBrandQuery
  ): Promise<{ data: IResponse[]; total: number }> => {
    return await axiosClient.delete('/abe/product/product-group', { params });
  },

  getEmailBrand: async (
    params: IGetEmailQuery
  ): Promise<{ data: IResponse[]; total: number }> => {
    return await axiosClient.get('/abe/product/get-users-by-group', { params });
  },

  getListOrderBranch: (params: any): Promise<IPagingResponse<any>> => {
    return axiosClient.get(`/abe/cart-order/branch/get-list-order-branch`, {
      params,
    });
  },

  createEmailBrand: async (
    params: IPostEmailQuery[]
  ): Promise<{ data: IResponse; total: number }> => {
    return await axiosClient.post(
      '/abe/product/product-group-permission',
      params
    );
  },

  createListEmailBrand: async (
    params: IPostEmailQuery[]
  ): Promise<{ data: IResponse; total: number }> => {
    const list_permission = { list_permission: params };
    return await axiosClient.post(
      '/abe/product/product-group-list-permission',
      list_permission
    );
  },
};

export default BrandApi;
